<template>
  <FormWrapper :class="$style.container">
    <InputText
      ref="description"
      v-model="description"
      data-test-id="FeedbackForm_detailsInput"
      label="What would make your experience with JumpCloud better?"
      name="description"
      placeholder="A short description"
      rules="required"
    />
    <Textarea
      ref="details"
      v-model="details"
      data-test-id="FeedbackForm_descriptionInput"
      fitContent
      label="What problem are you trying to solve? Have you seen this problem solved elsewhere?"
      name="details"
      placeholder="Give us the details"
      rules="required"
    />
    <Select
      ref="category"
      v-model="category"
      data-test-id="FeedbackForm_categoryInput"
      label="Category"
      :loadingOptions="loading"
      name="category"
      :options="options"
      placeholder="Select a category"
      rules="required"
      :totalOptions="options.length"
    />
    <SegmentedButton
      ref="priority"
      v-model="priority"
      :class="$style.segmentedButton"
      data-test-id="FeedbackForm_priorityInput"
      label="How important would the feature be to you?"
      name="priority"
      :options="$options.buttonOptions"
      rules="required"
    />
  </FormWrapper>
</template>

<script>
import {
  InputText,
  SegmentedButton,
  Select,
  Textarea,
} from '@jumpcloud/ui-components';
import { categories } from 'client/Support/FeedbackCategories';
import { sortBy } from 'lodash';
import FormWrapper from 'client/components/Forms/FormWrapper.vue';

const buttonOptions = [
  { label: 'Nice-to-Have', value: 'nice-to-have' },
  { label: 'Important', value: 'important' },
  { label: 'Critical', value: 'critical' },
];
export default {
  name: 'FeedbackForm',
  buttonOptions,
  categories,

  components: {
    InputText,
    FormWrapper,
    SegmentedButton,
    Select,
    Textarea,
  },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    const loading = true;
    const options = [
      ...sortBy(categories, ['name']),
      { value: 'other', name: 'Other', productServiceGroup: 'Other' },
    ];
    return {
      loading,
      options,
    };
  },

  computed: {
    category: {
      get() {
        return this.value.category.value;
      },
      set(newValue) {
        this.handleUpdate('category', newValue);
      },
    },
    description: {
      get() {
        return this.value.description;
      },
      set(newValue) {
        this.handleUpdate('description', newValue);
      },
    },
    details: {
      get() {
        return this.value.details;
      },
      set(newValue) {
        this.handleUpdate('details', newValue);
      },
    },
    priority: {
      get() {
        return this.value.priority;
      },
      set(newValue) {
        this.handleUpdate('priority', newValue);
      },
    },
  },

  methods: {
    handleUpdate(field, newValue) {
      if (field === 'category') {
        const selection = this.options.find(e => e.value === newValue);
        this.$emit('input', {
          ...this.value,
          [field]: selection,
        });
      } else {
        this.$emit('input', {
          ...this.value,
          [field]: newValue,
        });
      }
    },
  },
};
</script>

<style module scoped>
.container {
  width: 100%;
}
</style>
